import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-card-title',
  imports: [TranslocoPipe],
  templateUrl: './card-title.component.html',
})
export class CardTitleComponent {
  key = input.required<string>();
}
